import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex items-center space-x-2 text-gray-400"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Fetching tokens...", -1)
const _hoisted_3 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "min-w-full table-paper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Token"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "table-no-hover"
}
const _hoisted_8 = { colspan: "420" }
const _hoisted_9 = { class: "inline-flex items-center space-x-2 text-gray-400" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_11 = {
  key: 1,
  class: "table-no-hover"
}
const _hoisted_12 = {
  class: "text-gray-400",
  colspan: "420"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "whitespace-nowrap" }
const _hoisted_15 = { class: "flex items-center space-x-3" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  key: 1,
  class: "w-6 h-6 rounded bg-gray-100 flex"
}
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "whitespace-nowrap" }
const _hoisted_20 = { class: "w-px" }

import {
  computed, ref, toRefs, watchEffect,
} from 'vue';
import { PublicKey } from '@solana/web3.js';
import { AccountPresenter, WalletAccount } from '@/models';
import { getAccountRoute } from '@/utils';
import { fetchMultipleAccountContexts, FetchMultipleAccountsPipe } from '@/api';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: WalletAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

// Load tokens from the account.
watchEffect(() => account.value.tokens.load());
const loading = computed(() => account.value.tokens.loading);
const tokens = computed(() => account.value.tokens.all
  .filter(({ isNft }) => !isNft)
  .sort((a, b) => b.amount.cmp(a.amount)));

const multipleAccountsPipe: FetchMultipleAccountsPipe = async (accounts) => {
  const mints = accounts.map(({ account: x }) => {
    const mintBuffer = x?.accountInfo.data.slice(0, 32);
    return mintBuffer ? new PublicKey(mintBuffer) : null;
  });
  await fetchMultipleAccountContexts(mints);
};

// Pagination.
const perPage = 15;
const page = ref(1);
const paginatedTokens = computed(() => tokens.value.slice(
  (page.value - 1) * perPage,
  page.value * perPage,
));

return (_ctx: any,_cache: any) => {
  const _component_icon_loading = _resolveComponent("icon-loading")!
  const _component_base_table_separator = _resolveComponent("base-table-separator")!
  const _component_icon_coins = _resolveComponent("icon-coins")!
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!
  const _component_fetch_multiple_accounts = _resolveComponent("fetch-multiple-accounts")!
  const _component_base_table_overflow_container = _resolveComponent("base-table-overflow-container")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (_unref(loading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_icon_loading, { class: "w-5 h-5 text-gray-300 animate-spin" }),
        _hoisted_2
      ]))
    : (_unref(tokens).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This wallet has no tokens. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_base_table_overflow_container, null, {
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_base_table_separator),
                _createElementVNode("tbody", null, [
                  _createVNode(_component_fetch_multiple_accounts, {
                    addresses: _unref(paginatedTokens).map(tokenInfo => tokenInfo.token),
                    pipe: multipleAccountsPipe
                  }, {
                    default: _withCtx(({ accounts }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts, ({ addressAsString, account, presenter, loading }, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: account?.publicKey?.toBase58() ?? index
                        }, [
                          loading
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                                _createElementVNode("td", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_icon_loading, { class: "w-5 h-5 text-gray-300 animate-spin" }),
                                    _hoisted_10
                                  ])
                                ])
                              ]))
                            : (!account)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                  _createElementVNode("td", _hoisted_12, " Couldn't fetch token " + _toDisplayString(addressAsString), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("tr", {
                                  key: 2,
                                  onClick: ($event: any) => (_ctx.$router.push(_unref(getAccountRoute)(account)))
                                }, [
                                  _createElementVNode("td", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      (presenter.iconUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "w-6 h-6 object-cover rounded",
                                            src: presenter.iconUrl,
                                            alt: `Logo of ${presenter.name}`,
                                            onerror: "this.src='/broken-sm.svg';this.onerror='';"
                                          }, null, 8, _hoisted_16))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createVNode(_component_icon_coins, { class: "w-4 h-4 text-gray-400 m-auto" })
                                          ])),
                                      _createElementVNode("div", {
                                        textContent: _toDisplayString(account.tokenInfo?.name ?? account.publicKey.toBase58())
                                      }, null, 8, _hoisted_18)
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_19, _toDisplayString(account.amount.formattedWithSymbol), 1),
                                  _createElementVNode("td", _hoisted_20, [
                                    _createVNode(_component_icon_arrow_right, { class: "table-hover-icon" })
                                  ])
                                ], 8, _hoisted_13))
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["addresses"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_base_pagination, {
            class: "mt-8",
            page: page.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
            perPage: perPage,
            total: _unref(tokens).length
          }, null, 8, ["page", "total"])
        ]))
}
}

})